var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.326,
    height: 10.283,
    viewBox: "0 0 14.326 10.283",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icons_Arrow_Arrowhead_Right",
    "data-name": "Icons / Arrow / Arrowhead / Right",
    transform: "translate(0 0.567)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M337.072,138.954l3.179-3.95a.659.659,0,0,1,1.026.826l-2.841,3.529,2.947,3.536a.658.658,0,1,1-1.011.843l-3.292-3.95a.658.658,0,0,1-.007-.834",
    transform: "translate(-336.927 -134.758)",
    fill: "#868da0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M330.817,135a.659.659,0,0,1,1.026.826L329,139.359l2.946,3.536a.658.658,0,1,1-1.011.843l-3.291-3.95a.657.657,0,0,1-.007-.834Z",
    transform: "translate(-322.885 -134.759)",
    fill: "#868da0",
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M330.817,135a.659.659,0,0,1,1.026.826L329,139.359l2.946,3.536a.658.658,0,1,1-1.011.843l-3.291-3.95a.657.657,0,0,1-.007-.834Z",
    transform: "translate(-318.276 -134.759)",
    fill: "#868da0",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.4b5ba7e220c18be01080d3b6cbc5e3b9.svg";
export { ForwardRef as ReactComponent };